export const NON_RETRIABLE_ERROR_STATUSES = new Set([
  400, // Bad Request
  401, // Unauthorized
  403, // Forbidden
  404, // Not Found
  405, // Method Not Allowed
  409, // Conflict
  422, // Unprocessable Entity
]);

// Base HTTP error with status code
export class HttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly statusText = ''
  ) {
    super(message);
    this.name = 'HttpError';
  }

  isRetriableError(): boolean {
    return !NON_RETRIABLE_ERROR_STATUSES.has(this.status);
  }
}

export class AuthenticationError extends HttpError {
  constructor(status: 401 | 403, message?: string) {
    super(message || 'Authentication required', status);
    this.name = 'AuthenticationError';
  }
}
